@if (!loading) {
  <div class="grid">
    <div class="col-12 xl:col-10 xl:col-offset-1">
      <div class="grid">
        <div class="col-12 xl:col-8 lg:col-12">
          <p-card [header]="i18n.i18nLng()['CONTACTPAGETITLE']">
            <div [innerHTML]="contactInfo | safeHtml"
                 class="flex flex-column justify-content-center align-items-start gap-3 text-lg line-height-3 pb-3">
            </div>
            <!--
            <div class="pt-3 pb-3">
              <p-message severity="info" icon="pi pi-id-card" styleClass="inline-flex">
                {{ i18n.i18nLng()['CONTACTCLIENTIDINFO'] }}
              </p-message>
            </div>
            <div class="text-lg pb-3">
              {{ i18n.i18nLng()['CONTACTINFOFOOTER'] }}
            </div>
            -->
            <div class="grid">
              <div class="col-12 xl:col-6 flex gap-2 flex-column">
                <label for="clientid">{{ i18n.i18nLng()['YOURMERCHANTID'] }}</label>
                <input pInputText id="clientid" fluid [(ngModel)]="contactData.tenantId" [disabled]="true" pSize="large"/>
              </div>
              <div class="col-12 flex flex-column gap-2">
                <label for="subject">{{ i18n.i18nLng()['SUBJECT'] }}<sup class="sps-sup">*</sup></label>
                  <input pInputText
                         id="subject"
                         fluid
                         [(ngModel)]="contactData.subject"
                         [placeholder]="i18n.i18nLng()['PLACEHOLDER']"
                         [attr.aria-invalid]="contactDataInvalidFlags.subject ? 'true' : null"
                         [attr.aria-describedby]="contactDataInvalidFlags.subject ? 'subject-invalid-help' : null"
                         [ngClass]="contactDataInvalidFlags.subject ? 'ng-invalid ng-dirty' : null"
                         pSize="large"/>
                @if (contactDataInvalidFlags.subject) {
                  <small style="line-height: 1.5rem" class="text-error" role="alert" id="subject-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
                }
              </div>
              <div class="col-12 xl:col-6 flex flex-column gap-2">
                <label for="inquiry-reason">{{ i18n.i18nLng()['INQUIRYREASON'] }}<sup class="sps-sup">*</sup></label>
                <p-select [(ngModel)]="contactData.inquiryReason"
                          inputId="inquiry-reason"
                          [options]="inquiryReasonList"
                          [showClear]="false"
                          [placeholder]="i18n.i18nLng()['PLACEHOLDERSELECT']"
                          optionLabel="label"
                          optionValue="value"
                          class="w-full"
                          size="large"
                          [attr.aria-label]="i18n.i18nLng()['INQUIRYREASON']"
                          [attr.aria-invalid]="contactDataInvalidFlags.inquiryReason ? 'true' : null"
                          [attr.aria-describedby]="contactDataInvalidFlags.inquiryReason ? 'type-invalid-help' : null"
                          [ngClass]="contactDataInvalidFlags.inquiryReason ? 'ng-invalid ng-dirty' : null"/>
                @if (contactDataInvalidFlags.inquiryReason) {
                  <small style="line-height: 1.5rem" class="text-error" role="alert" id="reason-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
                }
              </div>
              <div class="col-12">
              <label for="inquiry-reason">{{ i18n.i18nLng()['INQUIRYMESSAGELABEL'] }}<sup class="sps-sup">*</sup></label>
              <textarea pTextarea
                        id="request"
                        rows="5"
                        fluid
                        style="resize: none"
                        [(ngModel)]="contactData.request"
                        [placeholder]="i18n.i18nLng()['REQUESTDESCRIPTION']"
                        [attr.aria-label]="i18n.i18nLng()['REQUESTDESCRIPTION']"
                        pSize="large"
                        [attr.aria-invalid]="contactDataInvalidFlags.request ? 'true' : null"
                        [attr.aria-describedby]="contactDataInvalidFlags.request ? 'type-invalid-help' : null"
                        [ngClass]="contactDataInvalidFlags.request ? 'ng-invalid ng-dirty' : null">
                </textarea>
                @if (contactDataInvalidFlags.request) {
                  <small style="line-height: 1.5rem" class="text-error" role="alert" id="type-invalid-help">{{ i18n.i18nLng()['REQUIREDHELP'] }}</small>
                }
              </div>
              <!--
              <div class="col-12">
                <p-fileupload #fileUpload
                              mode="advanced"
                              [multiple]="true"
                              [customUpload]="true"
                              [accept]="helper.attachmentMimeTypes()"
                              [fileLimit]="maxAttachmentFiles"
                              maxFileSize="10000000"
                              [chooseLabel]="i18n.i18nLng()['CHOOSEFILE']"
                              [cancelLabel]="i18n.i18nLng()['DELETEALLFILES']"
                              chooseStyleClass="p-button-outlined"
                              cancelStyleClass="p-button-outlined"
                              [cancelButtonProps]="cancelButtonProps"
                              [showUploadButton]="false"
                              [invalidFileSizeMessageSummary]="i18n.i18nLng()['INVALIDFILESIZESUMMARY']"
                              [invalidFileSizeMessageDetail]="i18n.i18nLng()['INVALIDFILESIZEDETAIL']"
                              [invalidFileTypeMessageSummary]="i18n.i18nLng()['INVALIDFILETYPESUMMARY']"
                              [invalidFileTypeMessageDetail]="i18n.i18nLng()['INVALIDFILETYPEDETAIL']"
                              [invalidFileLimitMessageSummary]="i18n.i18nLng()['INVALIDFILELIMITSUMMARY']"
                              [invalidFileLimitMessageDetail]="i18n.i18nLng()['INVALIDFILELIMITDETAIL']"
                              (onSelect)="addAttachmentFile($event, fileUpload)"
                              (onRemove)="removeAttachmentFile($event)"
                              (onClear)="clearAttachmentFiles()">
                  <ng-template #empty>
                    <div>{{ i18n.i18nLng()['DRAGDROPFILES'] }}</div>
                  </ng-template>
                </p-fileupload>
              </div>
              -->
            </div>
            <ng-template pTemplate="footer">
              <div class="flex w-full align-items-center justify-content-between">
                <div class="text-sm">
                  <sup class="sps-sup">*</sup><span><i>{{ i18n.i18nLng()['REQUIREDHELP'] }}</i></span>
                </div>
                <div class="flex gap-2">
                  <p-button icon="pi pi-arrow-right" iconPos="right" [label]="i18n?.i18nLng()['SEND']" (click)="saveInquiry()"/>
                </div>
              </div>
            </ng-template>
          </p-card>
        </div>
        <div class="col-12 xl:col-4">
          <sps-support-info gradientStyleClass="sps-background"></sps-support-info>
        </div>
      </div>
    </div>
  </div>
}
